import { render, staticRenderFns } from "./select-goods.vue?vue&type=template&id=05c179da&scoped=true"
import script from "./select-goods.vue?vue&type=script&lang=js"
export * from "./select-goods.vue?vue&type=script&lang=js"
import style0 from "./select-goods.vue?vue&type=style&index=0&id=05c179da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c179da",
  null
  
)

export default component.exports